import styled, { css } from 'styled-components';
import { AppFlex } from 'components/atoms';

export const Container = styled(AppFlex)`
    ${({ theme }) => css`
        margin-block: 24px;

        @media (${theme.sizes.mediaQueries.desktopMin}) {
            width: 600px;
        }
    `}
`;
